import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'globalFilter',
  pure: true
})
export class GlobalFilterPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;

 

    
    
  

    // -----------------
 
    return items.filter(item => {
        return Object.keys(item).some(key => {  

            if(key == "rgaRoleViewDtoList"){    

                return item[key].filter(arrayitem => {
                    
                    return Object.keys(arrayitem).some(key1 =>{
                      if(key1 == 'fullName' || key1 == 'categoryName' || key1 == 'majorSubject' || key1 == 'panelName'){
          
                        return String(item[key]).toLowerCase().includes(searchText.toLowerCase());
                    
                  }
                
                    })
                })

            }

            
            else  {
              //  return items
                return String(item[key]).toLowerCase().includes(searchText.toLowerCase());
               
      }
        });
      });
    


    // --------------------

    // return items.filter((item) =>{

    //     for(let prop in item){
    //         console.log(item)
    //         console.log(prop)
    //         console.log(item[prop])
    //         console.log(Array.isArray(item[prop]))
    //         if(Array.isArray(item[prop])){

              
    //             return Object.keys(item[prop]).some(key => {
    //                 return String(item[prop][key]).toLowerCase().includes(searchText.toLowerCase());
    //             })
    //         }
    //         else{
                
    //      return Object.keys(item).some(key => {
    //             return String(item[key]).toLowerCase().includes(searchText.toLowerCase());
    //         })

           
    //         }
    //     }
    // })
  




   
   }

}

